import React, {ReactNode} from "react";
import "./HomeButton.scss";

interface IProps {
  child: ReactNode;
  callback: () => void;
}

const HomeButton = (props: IProps) => {

  return (
    <div
      id="home-button"
      onClick={props.callback}
    >
      {props.child}
    </div>
  );
}

export default HomeButton;
